import {BCMSRecord ,BCMSRecordProperty} from "bcms-react";
import { Account } from "model";
/**
* @class Document
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.documents[0];
* const document = new Document(record);
* @property {NUMBER} _id - The id of the document
* @property {account} _account - The name of the document
* @property {STRING} _name - The name for the document
* @property {STRING} _image - the image path for the document
*/
export default class Document extends BCMSRecord{
    _id
    _account 
    _name
    _image  
    constructor (record){     
      super( record  ) 
    } 

    /**
     * @name sortDateAscending
     * @static
     * @param {ARRAY} documents - Array of Document instances
     * @memberof Document
     */
    static sortDateAscending(documents) {
      return documents.sort((a, b) => {
        if(a.date.isBefore(b.date)) { return 1; }
        else if(b.date.isBefore(a.date)) { return -1; }
        else{ return 0; }
      });
    }

    /**
     * @name sortDateDecending
     * @static
     * @param {ARRAY} documents - Array of Document instances
     * @memberof Document
     */
    static sortDateDecending(documents) {
      return documents.sort((a, b) => {
        if(a.date.isBefore(b.date)) { return -1; }
        else if(b.date.isBefore(a.date)) { return 1; }
        else{ return 0; }
      });
    }
  }
Document.define({
    "recordType":"documents",
    "recordIDProp":"id",
    "className" : "Document",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {NUMBER} - gets the id of the document
       * @property set {NUMBER} - sets the id of the document
       * @memberof Document 
       */
      BCMSRecordProperty.mapToNumber("id","_id"),
      /** 
       * @name account
       * @instance
       * @property get {STRING} - gets the account of the document
       * @property set {STRING} - sets the account of the document
       * @memberof Document 
       */
      BCMSRecordProperty.mapToClass("account","_account",()=>Account),
      /** 
       * @name name
       * @instance
       * @property get {STRING} - gets the name of the document
       * @property set {STRING} - sets the name of the document
       * @memberof Document 
       */
      BCMSRecordProperty.mapToString("name","_name"),
      /** 
       * @name image
       * @instance
       * @property get {STRING} - gets the image of the document
       * @property set {STRING} - sets the image of the document
       * @memberof Document 
       */
      BCMSRecordProperty.mapToString("image","_image"),

      /**
       * @name type
       * @instance
       * @property get {STRING} - gets the type of the document
       * @property set {STRING} - sets the type of the document
       * @memberof Document
       */
      BCMSRecordProperty.mapToString("type", "_type"),

      /**
       * @name date
       * @instance
       * @property get {STRING} - gets the date of the document
       * @property set {STRING} - sets the date of the document
       * @memberof Document
       */
      BCMSRecordProperty.mapToDate("date", "_date")
    ]
})




